import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import {
  ApiLog,
  APIService,
  Tokens,
  GetTokensQuery,
} from '../../API.service';
import { Router } from '@angular/router';
import { UserBillingStatus } from '../../doc2txt/utils/userBillingStatus';
import { HttpClient } from '@angular/common/http';
import { ZenObservable } from 'zen-observable-ts';
import { D2TApi } from 'src/app/doc2txt/utils/d2tApi';

@Component({
  selector: 'app-token-details-page',
  templateUrl: './token-details-page.component.html',
  styleUrls: ['./token-details-page.component.css'],
})
export class TokenDetailsPageComponent {
  private subscription: ZenObservable.Subscription | null = null;

  columnsToDisplay = ['path', 'datetime', 'fileUid', 'openDev', 'download', 'html'];
  tokenStr: string | null;
  totalCount: number | null | undefined;
  countCurrentMonth: number | null | undefined;
  dateIsoStr: string;
  items: (ApiLog | null)[];
  searchCount: number | null | undefined;
  path: string | null;
  token: GetTokensQuery | null;
  userBillingStatus: UserBillingStatus;
  loadingFlag: boolean = true;

  constructor(
    private api: APIService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.tokenStr = null;
    this.dateIsoStr = moment().startOf('month').add(2, 'hours').toISOString();
    this.path = null;
    this.token = null;
  }
  ngOnInit() {
    this.route.queryParams.subscribe(async (params) => {
      const token = await this.api.GetTokens(params['token']);
      this.token = token;
      this.tokenStr = token.uuid 
      await this.calcSum();
      this.loadingFlag = false;
    });
    this.subscription = this.api
      .OnUpdateSumitPaymentListener()
      .subscribe((event: any) => {
        this.loadingFlag = true;
        setTimeout(async () => {
          await this.calcSum();
          this.loadingFlag = false;
        }, 1000);
      });
  }

  private async getAdminTokenData(token: Tokens) {
    const d2tApi = new D2TApi(this.http, this.token);

    const request$ = d2tApi.getAdminTokenData(token.owner);

    return new Promise<{
      token: Tokens;
      totalCount: number;
      countCurrentMonth: number;
      countPrevMonth: number;
    }>((resolve, reject) => {
      request$.subscribe(async (adminTokenData: any) => {
        resolve({
          token: token,
          totalCount: adminTokenData.countTotal ?? 0,
          countCurrentMonth: adminTokenData.countCurrentMonth ?? 0,
          countPrevMonth: adminTokenData.countPreviousMonth ?? 0,
        });
      }, (error: any) => {
        reject(error);
      });
    });
  }
  private async calcSum() {
    if (!this.token) {
      return;
    }
    const token = this.token;
    const tokenData = await this.getAdminTokenData(token);
    this.totalCount = tokenData.totalCount;
    this.countCurrentMonth = tokenData.countCurrentMonth;
    // var startOfMonth = moment().startOf('month').toISOString();


    const userBillingStatus = new UserBillingStatus(
      this.api,
      this.http,
      this.token
    );
    await userBillingStatus.calcUserBillingStatus();
    this.userBillingStatus = userBillingStatus;

    this.search();
  }

  formatDatetime(datetime: string | null | undefined) {
    return moment(datetime).format('YYYY-MM-DD - HH:mm');
  }
  
  async search() {
    const d2tApi = new D2TApi(this.http, this.token);
    const request$ = d2tApi.getSearchApiLog(this.token?.owner, this.dateIsoStr);


    request$.subscribe(async (sumitPaymentMethodsList: any) => {
      this.searchCount = sumitPaymentMethodsList.countTotal;
      this.items = sumitPaymentMethodsList.items.map((item) => {
        return {
          ...item,
        datetime: this.formatDatetime(item?.datetime),
        } as ApiLog;

      });
    });    
  }

  openItemDev(item: ApiLog) {
    item.openFlag = true;
    const domain = 'https://dev.doc2txt.com';
    let path = `${domain}/receiptPage?uid=${item.fileUid}`;
    if (item.path?.includes('Receipt'))
      path = `${domain}/receiptPage?uid=${item.fileUid}`;
    if (item.path?.includes('Weedex'))
      path = `${domain}/weedexPage?uid=${item.fileUid}`;
    if (item.path?.includes('Passport'))
      path = `${domain}/passportPage?uid=${item.fileUid}`;
    if (item.path?.includes('Table'))
      path = `${domain}/ocrTable?uid=${item.fileUid}`;

    const url = path;
    window.open(url, '_blank');
  }

  openItem(item: ApiLog) {
    item.openFlag = true;
    let path = '/receiptPage';
    if (item.path?.includes('Receipt')) path = '/receiptPage';
    if (item.path?.includes('Weedex')) path = '/weedexPage';
    if (item.path?.includes('Passport')) path = '/passportPage';
    if (item.path?.includes('Table')) path = '/ocrTable';

    const url = this.router.serializeUrl(
      this.router.createUrlTree([path], { queryParams: { uid: item.fileUid } })
    );
    window.open(url, '_blank');
  }

  html(item: ApiLog) {
    item.openFlag = true;
    const url = `https://api3.doc2txt.com/showHtml?uid=${item.fileUid}`;
    window.open(url, '_blank');
  }

  download(item: ApiLog) {
    item.openFlag = true;

    const d2tApi = new D2TApi(this.http, this.token);
    const request$ = d2tApi.getFileForApiLog(item.fileUid);
    request$
      .pipe
      // finalize(() => {
      //   this.loadingFlag = false;
      // })
      ();
    request$.subscribe((data: any) => {
      if (data.error) {
        alert(data.error);
        return;
      }
      if (data.imgBase64) {
        if (data.type == 'pdf') {
          let pdfWindow = window.open('');
          if (pdfWindow) {
            pdfWindow.document.write(
              "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                encodeURI(data.imgBase64) +
                "'></iframe>"
            );
          }
        } else {
          const fileName = `${item.fileUid}.${data.type}`;
          var a = document.createElement('a'); //Create <a>
          a.href = 'data:image/jpg;base64,' + data.imgBase64; //Image Base64 Goes here
          a.download = fileName; //File name Here
          a.click(); //Downloaded file
        }
      } else {
        alert('download failed: data.imgBase64 is null');
      }
    });
  }
}
